// Same as Array.isArray() but typesafe: asserts unknown[] instead of any[]
export function isArray(value) {
    return Array.isArray(value);
}
